import * as React from 'react';
import Radium from 'radium';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';

import { changeText } from '../../contact_form/actions';

const RPT = React.PropTypes;

@connect(null, { changeText })
@Radium
export default class TeamMember extends React.Component {
  static propTypes = {
    email: RPT.string.isRequired,
    name: RPT.string.isRequired,
    photo: RPT.string.isRequired,
    position: RPT.string.isRequired,
    changeText: RPT.func.isRequired
  }

  handleClick() {
    // is there a better way?
    scroller.scrollTo('contactForm', { smooth: true });
    document.getElementsByName('email')[0].focus();
  }

  render() {
    const { email, name, photo, position } = this.props;

    return (
      <div style={styles.card}>
        <img src={photo} alt={name} style={styles.img} />
        <div style={styles.cardDescription}>
          <h4 style={[styles.h4, styles.centered]}>
            {name}<br />
            <em>{position}</em><br/>
            <a href={`mailto:${email}`}>{email}</a>
          </h4>
        </div>
      </div>
    );
  }
}

const styles = {
  card: {
    border: '1px solid #CCC',
    borderRadius: 5,
    display: 'flex',
    margin: '20px 1%',
    flexGrow: 1,
    width: '47%',
    minWidth: 300
  },
  img: {
    flex: '1 25%',
    padding: 10,
    width: 150,
    maxWidth: 150,
    height: 150,
    maxHeight: 150,
    borderRadius: 15
  },
  h3: {
    fontSize: 16,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginTop: 10
  },
  h4: {
    fontSize: 14
  },
  centered: {
    textAlign: 'center'
  },
  button: {
    margin: '0 auto',
    display: 'block'
  },
  cardDescription: {
    flex: '1 70%',
    margin: 'auto'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/team_member/index.jsx